// extracted by mini-css-extract-plugin
export default {"zoom":"ZoomHandler_zoom__ufiDz font-md-medium"};